/**
 * Utilitários para gerenciamento de autenticação e persistência de sessão
 */

export interface StoredToken {
  token: string;
  expiresAt: number;
}

/**
 * Verifica se um token está válido (não expirado)
 */
export const isTokenValid = (expiresAt: string | null): boolean => {
  if (!expiresAt) return false;
  return Date.now() < parseInt(expiresAt);
};

/**
 * Recupera o token válido do storage (localStorage ou sessionStorage)
 * Retorna null se não houver token válido
 */
export const getValidToken = (): string | null => {
  const persistentToken = localStorage.getItem("userToken");
  const persistentExpiry = localStorage.getItem("tokenExpiresAt");

  if (persistentToken && isTokenValid(persistentExpiry)) {
    return persistentToken;
  }

  const sessionToken = sessionStorage.getItem("userToken");
  const sessionExpiry = sessionStorage.getItem("tokenExpiresAt");

  if (sessionToken && isTokenValid(sessionExpiry)) {
    return sessionToken;
  }

  clearExpiredTokens();
  return null;
};

/**
 * Remove tokens expirados do storage
 */
export const clearExpiredTokens = (): void => {
  const persistentExpiry = localStorage.getItem("tokenExpiresAt");
  const sessionExpiry = sessionStorage.getItem("tokenExpiresAt");

  if (!isTokenValid(persistentExpiry)) {
    localStorage.removeItem("userToken");
    localStorage.removeItem("tokenExpiresAt");
  }

  if (!isTokenValid(sessionExpiry)) {
    sessionStorage.removeItem("userToken");
    sessionStorage.removeItem("tokenExpiresAt");
  }
};

/**
 * Limpa todos os dados de autenticação
 */
export const clearAuthData = (): void => {
  // Limpar localStorage
  localStorage.removeItem("userToken");
  localStorage.removeItem("tokenExpiresAt");
  localStorage.removeItem("rememberedEmail");
  localStorage.removeItem("rememberMe");

  sessionStorage.removeItem("userToken");
  sessionStorage.removeItem("tokenExpiresAt");
};

/**
 * Verifica se existe uma sessão lembrada
 */
export const hasRememberedSession = (): boolean => {
  return (
    localStorage.getItem("rememberMe") === "true" &&
    !!localStorage.getItem("rememberedEmail")
  );
};
